import request from '@/config/axios';

/**
 * BasicDocGetBlockTree
 * 获取基础文档树
 * @return Array {}
 */
export function BasicDocGetBlockTree(data) {
  return request({
    url: '/opendoc/preview/getOpenDocBlockTreeByDocId',
    method: 'GET',
    params: data
  });
}

/**
 * BasicDocGetDocDetails
 * 获取指定文档详情
 * @return Array {}
 */
export function BasicDocGetDocDetails(data) {
  return request({
    url: '/opendoc/preview/getOpenDocBlockById',
    method: 'GET',
    params: data
  });
}